module.exports = __webpack_public_path__ + "img/210.efcbfcf2.png";